import "../i18n";
import { Sentry } from "../sentryInstrumentReact";
import React, { useState } from 'react';
import Cookies from 'js-cookie';

import { useCart } from './CartContext';

function CheckoutDonation() {
  const { rendering, donation, setDonation, setCartTotal, setCart } = useCart();
  const [donationValue, setDonationValue] = useState(donation);
  const [donationError, setDonationError] = useState('');
  const csrftoken = Cookies.get('csrftoken');

  function handleDonationChange(e) {
    setDonationValue(e.target.value);
  }

  function handleBlur(e) {
    // const value = parseFloat(donationValue);
    // if (!isNaN(value)) {
    //   setDonationValue(value.toFixed(2));
    //   setDonation(value.toFixed(2));
    // }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const value = parseFloat(donationValue).toFixed(2);
    if (!isFinite(value)) {
      setDonationError(window.gettext("Error: Donations are optional and have to be more than $0."));
      return;
    } else if (value <= 0) {
      setDonationError(window.gettext("Error: Donation needs to be positive number."));
      return;
    }

    // TODO: check if donation is valid value: number, not negative, etc.
    try {

      const response = await fetch("/store/_api/cart/donation/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": csrftoken
        },
        body: JSON.stringify(value),
      });

      if (!response.ok) {
        throw new Error("Failed to add donation");
      }

      const cartObject = await response.json();
      setCart(cartObject);
      setCartTotal(parseFloat(cartObject.total).toFixed(2));
      setDonation(parseFloat(cartObject.donation).toFixed(2));
      setDonationValue('');
      setDonationError('');

    } catch (error) {
	  if (Sentry && Sentry.getClient()) {
		Sentry.captureException(error);
	  }
      setDonationError("Error: an error occurred while adding your donation.");

    }
    

  }


  if (rendering) {
    return (
      <></>
    );
  }

  let formClasses = "form-group";
  if (donationError !== '') {
    formClasses += " error";
  }


  return (
    <>
      {donation == '' && 
        <fieldset id="add_donation" className="highlight">
          <div className="form-row donate-form-row">
            <h2 className="h6 mb-0 hide">{window.gettext("Add a Donation?")}</h2>
            <p>{window.gettext("Your purchase helps women thrive in Christ. Add a donation to impact even more women around the world.")}</p>
            <div className="form-group-row">
              <div className={formClasses}>
                <label htmlFor="donate_amount" className="number-label active">{window.gettext("Donation Amount")}</label>
                <input 
                  type="number" 
                  min="0"
                  step="0.01"
                  className="form-control not-dynamic" 
                  value={donationValue} 
                  name="donation" 
                  id="donate_amount"
                  onChange={handleDonationChange}
                  onBlur={handleBlur}
                />
              </div>
              <button className="btn btn-sm btn-primary-light" onClick={handleSubmit}>{window.gettext("Add a Donation")}</button>
            </div>
            {donationError && 
              <p className="error">{donationError}</p>
            }
          </div>
        </fieldset>
      }
    </>
  );
}

export default CheckoutDonation;
